<template>
  <generic-container
    class="ui container"
    :title="selected_professor.setup.name + ' - ' + this.$t('sections')"
    icon="user tie"
    :show_plus="true"
    v-if="selected_professor"
    :header_buttons="header_buttons"
    @add="add"
  >
    <div class="description">
      <div class="ui grid">
        <div class="five wide column">
          <div
            class="ui top attached vertical menu"
            ref="tabs"
            v-if="sections.length"
            style="width: 100%"
          >
            <a
              class="item"
              :data-tab="'t' + section.uuid"
              v-for="(section, sidx) in sections"
              :key="sidx"
            >
              <div class="ui small header">
                <div
                  class="content"
                  v-if="section.crs_course && section.crs_course.name"
                >
                  {{ section.crs_course.name }}
                  <div
                    class="ui basic icon label"
                    @click="remove_section(section, sidx)"
                  >
                    <i class="red trash icon"></i>
                  </div>
                  <div
                    class="ui basic icon label"
                    :data-tooltip="$t('students in section')"
                  >
                    <i class="users icon"></i>
                    {{ section.preinscriptions.length }}
                  </div>
                  <div class="sub header">
                    {{ section.name }}
                    <small>| {{ section.setup.schedule }} </small>
                  </div>
                </div>
                <div class="content" v-else>
                  {{ $t("unknown course") }}
                  <div
                    class="ui basic icon label"
                    @click="remove_section(section, sidx)"
                  >
                    <i class="red trash icon"></i>
                  </div>
                  <div class="sub header">
                    {{ section.name }}
                    <small>| {{ section.setup.schedule }} </small>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="eleven wide column">
          <div
            class="ui bottom attached tab segment"
            :data-tab="'t' + section.uuid"
            v-for="(section, sidx) in sections"
            :key="sidx"
          >
            <professor-section
              :section="section"
              :careers="careers"
              :branches="branches"
              :studying_times="studying_times"
              :schedules="schedules"
              :days="days"
              :season="season"
              :professor="selected_professor"
              :users="users"
            />
          </div>
        </div>
      </div>

      <div class="ui icon warning message" v-if="!sections.length">
        <i class="inbox icon"></i>
        <div class="content">
          <div class="header">
            {{ $t("alert") }}
          </div>
          <p>{{ $t("no sections created yet") }}</p>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast, enterprise_setup } from "@/utils";
import { v4 } from "uuid";

import ProfessorSection from "./ProfessorSection";

export default {
  name: "CourseAssignationDistributionProfesssorBasedProfessorDetail",
  props: {
    careers: Array,
    branches: Array,
    studying_times: Array,
    schedules: Array,
    days: Array,
    season: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  components: { GenericContainer, ProfessorSection },
  data() {
    return {
      selected_professor: undefined,
      sections: [],
      users: [],
      header_buttons: [
        {
          icon: "arrows alternate horizontal",
          tooltip: this.$t("alternate view"),
          click: this.alternate_view,
        },
      ],
    };
  },
  methods: {
    alternate_view() {
      this.$emit("alternate_view");
    },
    setProfessor(professor) {
      let vm = this;
      vm.selected_professor = professor;

      /**
       * Get courses of this professor for the specified season
       */
      let distribution_uuid = this.$route.query.i;
      if (distribution_uuid) {
        local_api(
          vm,
          "post",
          "/course/assignation_professor_based/do-get-professor-courses",
          {
            u: distribution_uuid,
            p: professor.uuid,
          },
        )
          .then((sections) => {
            vm.sections = sections.map((s) => {
              s.exists_in_database = true;
              s.preinscriptions = s.crs_assignation_preinscriptions;
              if (s && s.crs_course)
                s.crs_course.course_id = String(s.crs_course.course_id);
              return s;
            });

            setTimeout(() => {
              window.jQuery(vm.$refs.tabs).find(".item").tab();
            }, 500);
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course distribution found"));
      }
    },
    add() {
      let vm = this;
      vm.sections.push({
        uuid: v4(),
        name: "",
        crs_course: {},
        setup: { schedule: "" },
        preinscriptions: [],
      });

      setTimeout(() => {
        window.jQuery(vm.$refs.tabs).find(".item").tab();
      }, 1000);
    },
    setUsers(users) {
      this.users = users;
    },
    remove_section(section, index) {
      let vm = this;
      // console.log(section);
      vm.$alertify.confirm(
        vm.$t("are you sure to remove section?"),
        function () {
          if (section.exists_in_database == true) {
            local_api(
              vm,
              "post",
              "/course/assignation_professor_based/do-delete-section",
              {
                u: section.uuid,
              },
            )
              .then(() => {
                vm.sections.splice(index, 1);
              })
              .catch((err) => {
                error_toast(err);
              });
          } else vm.sections.splice(index, 1);
        },
      );
    },
  },
};
</script>
